// import { getAdvertisers } from '@/api/advertiser'
import { getAdvertisers2 } from '@/api/open'

export default {
    components: {
    },
    model: {
        prop: 'ids',
        event: 'change'
    },
    props: ['type', 'ids', 'maxTagCount', 'disabled', 'isNew', 'mediaCorporation'],
    data () {
        return {
            timeout: null,
            loading: false,
            advertisers: [],
            values: [],
            open: false,
            outIds: '',
            showSearchBox: false,
            maxTag: 5,
            modelType: 'multiple',
        }
    },
    computed: {
        // 计算属性：过滤后的广告商列表（排除搜索无结果的情况）
        filteredAdvertisers() {
          return this.advertisers || [];
        },

        // 新逻辑：只包含可用的广告主（非漂移）
        availableAdvertisers() {
            return this.advertisers.filter(adv => !adv.is_drift);
        },
        
        // 计算属性：判断是否所有选项都被选中
        isAllSelected() {
          return this.filteredAdvertisers.length > 0 && 
                 this.values.length === this.filteredAdvertisers.length + 1 && 
                 this.values.includes('all');
        }
      },
    watch: {},
    mounted () {
        if (this.maxTagCount <= 1) {
            this.modelType = null
        }
        this.maxTag = this.maxTagCount || this.maxTag
        if (this.ids && this.ids.length > 0) {
            let json = {
                id: this.ids
            }
            if (this.outIds) {
                json.name = this.outIds
            }
            if (this.type) {
                json.type = this.type
            }
            if (this.isNew) {
                json.is_new = this.isNew
            }
            if (this.mediaCorporation) {
                json.media_corporation = this.mediaCorporation
            }

            getAdvertisers2(json, this.type).then(res => {
                let values = []
                res.data.list.forEach(item => {
                    values.push({ id: item.id, name: item.name, remark: item.remark, is_drift: item.is_drift || false })
                })
                this.advertisers = values
                // 原逻辑
                // this.values = Object.assign([], this.ids)
                // 新逻辑
                // 初始化时过滤掉漂移的广告主
                this.values = this.ids.filter(id => {
                    const adv = values.find(a => a.id === id);
                    return adv && !adv.is_drift;
                });
            })
        }
    },
    methods: {
        handleSearch(name) {
            this.search(name, data => (this.advertisers = data))
        },
        handleChange(ids) {
            console.log('ids', ids)
            // this.values = ids
            // this.$emit('change', this.values)
            ids = ids ? (Array.isArray(ids) ? ids : [ids]) : [];

            if (ids.includes('all')) {
                // 当用户点击"全选"时，直接选中所有广告商（不包含"all"）
                // 原逻辑
                // this.values = this.filteredAdvertisers.map(item => item.id);

                // 新逻辑
                this.values = this.availableAdvertisers.map(item => item.id);
              } else {
                // 正常更新选中值
                // 原逻辑
                // this.values = ids;

                // 新逻辑
                // 过滤掉可能被传入的漂移广告主 ID（防御）
                this.values = ids.filter(id => {
                    const adv = this.advertisers.find(a => a.id === id);
                    return adv && !adv.is_drift;
                });
              }
              
              // 触发父组件事件，保持原有功能
              this.$emit('change', this.values);
              
        },
        handleBlur() {
            console.log('失去焦点')
            this.open = false
            this.$emit('blur')
        },
        handleDeselect(value) {
            console.log('下拉取消:', value);
            this.open = true
            setTimeout(() => {
                this.$refs.selector.focus();
            }, 0);
        },
        handleFocus() {
            this.open = true
        },
        search(name, callback) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            const getData = () => {
                this.loading = true
                let count = this.outIds
                    .split(/\r?\n/)      // 按换行拆分，兼容 Windows \r\n
                    .filter(item => item.trim() !== '') // 去掉空行
                    .length
                let page_size = 20 
                if (this.type == 'kuaishou') {
                    page_size = 100
                }
                if (count > 20) {
                    // 设置固定最大值，防止上计划广告过多导致卡住的情况
                    page_size = 100
                }
                getAdvertisers2({ name: name, type:this.type, is_new: this.isNew, media_corporation: this.mediaCorporation, page_size:page_size}, this.type).then(res => {
                    const data = [];
                    res.data.list.forEach(res => {
                        data.push({
                            id: res.id,
                            name: res.name,
                            remark: res.remark,
                            is_drift: res.is_drift || false,// 新逻辑
                        });
                    });
                    callback(data);
                }).finally(() => {
                    this.loading = false
                })
            }
            this.timeout = setTimeout(getData, 300);
        },
        idSearch() {
            this.showSearchBox = true
        },
        closeSearchBox() {
            this.showSearchBox = false
        },
        searchByIds() {
            this.showSearchBox = false
            this.search(this.outIds, data => {
                this.advertisers = data
                setTimeout(() => {
                    this.$refs.selector.focus()
                }, 50)
            })
        }
    }
}
